import { buildItemsTable, buildItemsTableForDelivery, formatTemplate } from "./Style";
import { Quote } from "../Quotes";
import { ClientDetails } from "../ClientDetails";
import { Company } from "../Companies";
import { FinancialSummary, Item } from "../Items";
import { ItemDelivery, ItemDeliveryDate } from "../QuotesDelivery";
import { Client } from "../Clients";
import dayjs from "dayjs";
import { Button } from "@mui/material";

const DATE_INPUT_FORMAT = "YYYY-MM-DD";
const DATE_OUTPUT_FORMAT = "DD MMM YYYY";


export const QuoteHTML = (quote: Partial<Quote>, details: Partial<ClientDetails>, client: Partial<Client>, company: Partial<Company>, items: Array<Item>, summary: FinancialSummary) => {
    const text = `
<!DOCTYPE html>
<html>

<head>
    <meta charset="UTF-8">
    <title>{{ CostCentre }} Quote {{ QuoteNo }}</title>
    <style>
        [[ GITHUB_STYLESHEET ]]
    </style>
</head>

<body>
    [[ EKASI_HEADER ]]

    <!--    Heading    -->
    <h1 style="text-align: center;"> QUOTE </h1>

    <!--    Details    -->
    <table class="utable" style="width: 100%">
        <colgroup>
            <col span="1" style="width: 50%;">
            <col span="1" style="width: 25%;;">
            <col span="1" style="width: 25%;">
        </colgroup>
        <tr>
            <td> To: {{ CompanyName }} </td>
            <td> Quote No: </td>
            <td class="cell_underline"> {{ QuoteNo }} </td>
        </tr>
        <tr>
            <td> {{ CompanyAddr0 }} </td>
            <td> Date: </td>
            <td class="cell_underline"> {{ QuoteDate }} </td>
        </tr>
        <tr>
            <td> {{ CompanyAddr1 }} </td>
            <td> Valid Until: </td>
            <td class="cell_underline"> {{ ValidUntil }} </td>
        </tr>
        <tr>
            <td> {{ CompanyAddr2 }} </td>
            <td> Payment Term: </td>
            <td class="cell_underline"> {{ PaymentTerm }} </td>
        </tr>
        <tr>
            <td> VAT number: {{ CompanyVAT }} </td>
            <td> Cost Centre: </td>
            <td class="cell_underline"> {{ CostCentre }} </td>
        </tr>
    </table>

    <div>
        <p><b> Delivery Details </b></p>
        <p> Contact Person: {{ ContactPerson }} </p>
        <p> Contact Details: {{ ContactDetails }} </p>
        <p> Delivery Address: {{ DeliveryAddress }} </p>
        <p> Delivery Period: Within 30 Days of receiving PO (Depending on Stock Availability) </p>
    </div>
    <br>

    <!--    Items    -->
    {{ ItemsTable }}
    <br>

    <h2></h2>
    <h3>END</h3>

</body>

</html>
`
    const args = {
        CompanyName: company.name,
        CompanyAddr0: company.addr0,
        CompanyAddr1: company.addr1,
        CompanyAddr2: company.addr2,
        CompanyVAT: company.vat_registration,
        QuoteNo: quote.quote_no,
        QuoteDate: dayjs(quote.quote_date, DATE_INPUT_FORMAT).format(DATE_OUTPUT_FORMAT),
        ValidUntil: dayjs(quote.valid_until, DATE_INPUT_FORMAT).format(DATE_OUTPUT_FORMAT),
        PaymentTerm: (quote.payment_term || 30) + " Days",
        CostCentre: client.name,
        ContactPerson: details.person,
        ContactDetails: details.contact,
        DeliveryAddress: details.address,
        ItemsTable: buildItemsTable(quote, items, summary),
    };

    return formatTemplate(text, args);
}

export const DeliveryHTML = (quote: Partial<Quote>, details: Partial<ClientDetails>, client: Partial<Client>, items: Array<Item>, itemDeliveries: Array<ItemDelivery> | undefined) => {
    const text = `
<!DOCTYPE html>
<html>

<head>
    <meta charset="UTF-8">
    <title>{{ CostCentre }} Delivery Note {{ QuoteNo }}</title>
    <style>
        [[ GITHUB_STYLESHEET ]]
    </style>
</head>

<body>
    [[ EKASI_HEADER ]]

    <!--    Heading    -->
    <h1 style="text-align: center;"> DELIVERY NOTE </h1>

    <!--    Details    -->
    <table class="utable" style="width: 100%">
        <colgroup>
            <col span="1" style="width: 50%;">
            <col span="1" style="width: 25%;">
            <col span="1" style="width: 25%;">
        </colgroup>
        <tr>
            <td><b> Delivery Details </b></td>
            <td> Delivery Note No: </td>
            <td class="cell_underline"> {{ QuoteNo }} </td>
        </tr>
        <tr>
            <td> Contact Person: {{ ContactPerson }} </td>
            <td> Date: </td>
            <td class="cell_underline"> {{ QuoteDate }} </td>

        </tr>
        <tr>
            <td> Contact Details: {{ ContactDetails }} </td>
            <td> PO Number: </td>
            <td class="cell_underline"> {{ PONo }} </td>
        </tr>
        <tr>
            <td> Delivery Address: {{ DeliveryAddress }} </td>
            <td> Cost Centre: </td>
            <td class="cell_underline"> {{ CostCentre }} </td>
        </tr>
        <tr>
            <td></td>
            <td> Delivery Period: </td>
            <td class="cell_underline"> Within 30 Days of receiving PO (Depending on Stock Availability) </td>
        </tr>
    </table>
    <br>

    <!--    Items    -->
    {{ ItemsTable }}
    <br>

    <!--    Footer    -->
    <table class="utable" style="width: 100%; border-spacing: 16px">
        <colgroup>
            <col span="1" style="width: 50%;">
            <col span="1" style="width: 50%;">
        </colgroup>
        <tr>
            <td class="cell_underline"><b> Receiver Name: </b></td>
        </tr>
        <tr>
            <td class="cell_underline"><b> Receiver Signature: </b></td>
            <td class="cell_underline"><b> Supplier Signature: </b></td>
        </tr>
        <tr>
            <td class="cell_underline"><b> Date: </b></td>
        </tr>
    </table>

    <h2></h2>
    <h3>END</h3>

</body>

</html>
`

    const args = {
        QuoteNo: quote.quote_no || "",
        QuoteDate: quote.quote_date ? dayjs(quote.quote_date, DATE_INPUT_FORMAT).format(DATE_OUTPUT_FORMAT) : "",
        PaymentTerm: (quote.payment_term || 30) + " days",
        CostCentre: client.name || "",
        ContactPerson: details.person || "",
        ContactDetails: details.contact || "",
        DeliveryAddress: details.address || "",
        PONo: quote.po_no || "",
        ItemsTable: buildItemsTableForDelivery(quote, items, itemDeliveries || []),
    };

    return formatTemplate(text, args);
}

export const InvoiceHTML = (quote: Partial<Quote>, details: Partial<ClientDetails>, client: Partial<Client>, company: Partial<Company>, items: Array<Item>, summary: FinancialSummary, itemDeliveries: Array<ItemDelivery> | undefined, itemDeliveryDate: ItemDeliveryDate | undefined) => {
    const text = `
<!DOCTYPE html>
<html>

<head>
    <meta charset="UTF-8">
    <title>{{ CostCentre }} Invoice {{ QuoteNo }}</title>
    <style>
        [[ GITHUB_STYLESHEET ]]
    </style>
</head>

<body>
    [[ EKASI_HEADER ]]

    <!-- Heading   -->
    <h1 style="text-align: center;"> TAX INVOICE </h1>

    <!--    Address    -->
    <table class="utable" style="width: 100%">
        <colgroup>
            <col span="1" style="width: 50%;">
            <col span="1" style="width: 25%;">
            <col span="1" style="width: 25%;">
        </colgroup>
        <tr>
            <td> To: {{ CompanyName }} </td>
            <td> Tax Invoice Number: </td>
            <td class="cell_underline"> {{ QuoteNo }} </td>
        </tr>
        <tr>
            <td> {{ CompanyAddr0 }} </td>
            <td> Tax Invoice Date: </td>
            <td class="cell_underline"> {{ TaxDate }} </td>
        </tr>
        <tr>
            <td> {{ CompanyAddr1 }} </td>
            <td> PO Date: </td>
            <td class="cell_underline"> {{ PODate }} </td>
        </tr>
        <tr>
            <td> {{ CompanyAddr2 }} </td>
            <td> PO Number: </td>
            <td class="cell_underline"> {{ PONo }} </td>
        </tr>
        <tr>
            <td> VAT: {{ CompanyVAT }} </td>
            <td> Payment Term: </td>
            <td class="cell_underline"> {{ PaymentTerm }} </td>
        </tr>
    </table>

    <div>
        <p><b> Delivery Details </b></p>
        <p> Attention: {{ ContactPerson }} </p>
        <p> Contact Details: {{ ContactDetails }} </p>
        <p> Delivery Details: {{ DeliveryAddress }} </p>
        <p> Delivery Period: Within 30 Days of receiving PO (Depending on Stock Availability) </p>
    </div>

    <br>

    <!--    Items    -->
    {{ ItemsTable }}
    <br>

    <!--    Footer    -->
    <table class="utable" style="width: 100%">
        <colgroup>
            <col span="1" style="width: 50%;">
            <col span="1" style="width: 50%;">
        </colgroup>
        <tr>
            <td> </td>
            <td> <b>Banking Details: </b>Ekasi Prime Investments - FNB</td>
        </tr>
        <tr>
            <td> </td>
            <td> <b>Account Number: </b>62694472433 </td>
        </tr>
        <tr>
            <td> </td>
            <td> <b>Cheque Account - Branch: </b>260216 </td>
        </tr>
        <tr>
            <td></td>
            <td> <b>Contact: </b>jade@ekasi-prime.com </td>
        </tr>
    </table>

    <h2></h2>
    <h3>END</h3>

</body>

</html>
`

    const args = {
        CompanyName: company.name || "",
        CompanyAddr0: company.addr0 || "",
        CompanyAddr1: company.addr1 || "",
        CompanyAddr2: company.addr2 || "",
        CompanyVAT: company.vat_registration || "",
        PONo: quote.po_no || "",
        PODate: dayjs(quote.po_date, DATE_INPUT_FORMAT).format(DATE_OUTPUT_FORMAT) || "",
        TaxDate: itemDeliveryDate === undefined ? "" : dayjs(itemDeliveryDate.tax_date, DATE_INPUT_FORMAT).format(DATE_OUTPUT_FORMAT),
        QuoteNo: itemDeliveryDate === undefined ? (quote.quote_no || "") : (quote.quote_no || "") + (itemDeliveryDate.iteration > 0 ? " - " + itemDeliveryDate.iteration : ""),
        QuoteDate: dayjs(quote.quote_date, DATE_INPUT_FORMAT).format(DATE_OUTPUT_FORMAT) || "",
        ValidUntil: quote.valid_until || "",
        PaymentTerm: (quote.payment_term || 30) + " Days",
        CostCentre: client.name || "",
        ContactPerson: details.person || "",
        ContactDetails: details.contact || "",
        DeliveryAddress: details.address || "",
        ItemsTable: buildItemsTable(quote, items, summary, itemDeliveries),
    };

    return formatTemplate(text, args);
}

export const CreditHTML = (quote: Partial<Quote>, details: Partial<ClientDetails>, client: Partial<Client>, company: Partial<Company>, items: Array<Item>, summary: FinancialSummary, itemDeliveries: Array<ItemDelivery> | undefined, itemDeliveryDate: ItemDeliveryDate | undefined) => {
    const text = `
<!DOCTYPE html>
<html>

<head>
    <meta charset="UTF-8">
    <title>{{ CostCentre }} Credit Note {{ QuoteNo }}</title>
    <style>
        [[ GITHUB_STYLESHEET ]]
    </style>
</head>

<body>
    [[ EKASI_HEADER ]]

    <!-- Heading   -->
    <h1 style="text-align: center;"> CREDIT NOTE </h1>

    <!--    Address    -->
    <table class="utable" style="width: 100%">
        <colgroup>
            <col span="1" style="width: 50%;">
            <col span="1" style="width: 25%;">
            <col span="1" style="width: 25%;">
        </colgroup>
        <tr>
            <td> To: {{ CompanyName }} </td>
            <td> Tax Invoice Number: </td>
            <td class="cell_underline"> {{ QuoteNo }} </td>
        </tr>
        <tr>
            <td> {{ CompanyAddr0 }} </td>
            <td> Tax Invoice Date: </td>
            <td class="cell_underline"> {{ TaxDate }} </td>
        </tr>
        <tr>
            <td> {{ CompanyAddr1 }} </td>
            <td> PO Date: </td>
            <td class="cell_underline"> {{ PODate }} </td>
        </tr>
        <tr>
            <td> {{ CompanyAddr2 }} </td>
            <td> PO Number: </td>
            <td class="cell_underline"> {{ PONo }} </td>
        </tr>
        <tr>
            <td> VAT: {{ CompanyVAT }} </td>
            <td> Payment Term: </td>
            <td class="cell_underline"> {{ PaymentTerm }} </td>
        </tr>
    </table>

    <div>
        <p><b> Delivery Details </b></p>
        <p> Attention: {{ ContactPerson }} </p>
        <p> Contact Details: {{ ContactDetails }} </p>
        <p> Delivery Details: {{ DeliveryAddress }} </p>
        <p> Delivery Period: Within 30 Days of receiving PO (Depending on Stock Availability) </p>
    </div>

    <br>

    <!--    Items    -->
    {{ ItemsTable }}
    <br>

    <h2></h2>
    <h3>END</h3>

</body>

</html>
`

    const args = {
        CompanyName: company.name,
        CompanyAddr0: company.addr0,
        CompanyAddr1: company.addr1,
        CompanyAddr2: company.addr2,
        CompanyVAT: company.vat_registration,
        PONo: quote.po_no,
        PODate: dayjs(quote.po_date, DATE_INPUT_FORMAT).format(DATE_OUTPUT_FORMAT),
        TaxDate: itemDeliveryDate === undefined ? "" : dayjs(itemDeliveryDate.tax_date, DATE_INPUT_FORMAT).format(DATE_OUTPUT_FORMAT),
        QuoteNo: itemDeliveryDate === undefined ? (quote.quote_no || "") : (quote.quote_no || "") + (itemDeliveryDate.iteration > 0 ? " - " + itemDeliveryDate.iteration : ""),
        QuoteDate: dayjs(quote.quote_date, DATE_INPUT_FORMAT).format(DATE_OUTPUT_FORMAT),
        ValidUntil: dayjs(quote.valid_until, DATE_INPUT_FORMAT).format(DATE_OUTPUT_FORMAT),
        PaymentTerm: (quote.payment_term || 30) + " Days",
        CostCentre: client.name,
        ContactPerson: details.person,
        ContactDetails: details.contact,
        DeliveryAddress: details.address,
        ItemsTable: buildItemsTable(quote, items, summary, itemDeliveries),
    };

    return formatTemplate(text, args)
}

export function pdfFileName(quote: Partial<Quote>, type: string, itemDeliveryDate: Partial<ItemDeliveryDate> = {}): string {
    const quoteNo = quote.quote_no + ((itemDeliveryDate?.iteration || 0) > 0 ? " - " + itemDeliveryDate.iteration : "");
    const pon = (quote.po_no && type !== "Quote") ? (quote.po_no + " ") : "";
    if (quote.quote_title) {
        if (quote.business_unit) {
            return pon + quote.quote_title + " " + quote.business_unit + " " + type + " " + quoteNo + ".pdf";
        } else {
            return pon + quote.quote_title + " " + type + " " + quoteNo + ".pdf";
        }
    } else if (quote.business_unit) {
        return pon + quote.business_unit + " " + type + " " + quoteNo + ".pdf";
    } else {
        return pon + type + " " + quoteNo + ".pdf";
    }
}


const downloadPDF = async (content: string, filename: string) => {
    const response = await fetch("/api/v1/gen-pdf", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ "content": content, "filename": filename })
    });
    const data = await response.blob();
    console.log(data);
    var a = document.createElement("a");
    a.href = window.URL.createObjectURL(data);
    a.download = filename;
    a.click();
}

export const DownloadPDFButton = ({ filename, content, children} : { filename: string, content: string, children: any}) => {
    return (
        <Button variant="text" onClick={() => downloadPDF(content, filename)}>
            {children}
        </Button>
    )
}